import { discoveryService, loyaltyService, tripAdvisorService, hotelService } from '@/infrastructure/Factory'
import { Occupancy } from '@/domain/Occupancy'
import { DateFactory, translate } from 'rhg-vue-common'
import {
  getQueryParams,
  mapHotelFiltersParams,
  serializeOccupancy,
  getOccupancyFromAdultsAndChild,
  getPageLanguage
} from '@/infrastructure/Utils'
import cloneDeep from 'lodash/cloneDeep'
import { stringify } from 'qs'
import { isLocalEnviroment, taxRegion } from '@/infrastructure/Configuration'
export default {
  async getHotels({ commit, state }) {
    const hotelFilters = mapHotelFiltersParams(state.promotion?.hotelFilters || '')
    const largeNumberGetAllHotels = 10000
    const hotels = await discoveryService.getHotels(hotelFilters, largeNumberGetAllHotels)
    commit('updateHotels', hotels)
  },
  async getDestinationHotels({ commit }) {
    const hotels = await discoveryService.getDestinationHotels()
    commit('updateHotels', hotels)
  },
  async getDestinationsForCountryOrCity({ commit }, code) {
    let hotels = []
    if (window.countryCode) {
      hotels = await discoveryService.getDestinationsCountryHotels(code)
    } else {
      hotels = await discoveryService.getDestinationsCityHotels(code)
    }
    commit('updateHotels', hotels)
  },
  async updateHotels({ commit }, hotels) {
    commit('updateHotels', hotels)
  },
  async getOrderedCountries({ getters, commit, dispatch }) {
    let position = 0
    const result = []

    await dispatch('getHotels')

    await dispatch('buildCountryFilterData', getters.hotels)
    await dispatch('buildCityFilterData', getters.hotels)
    await dispatch('buildHotelFilterData', getters.hotels)

    await dispatch('getFilterParams', getters.promotion)

    const countries = getters.hotelsByLocation
      .map(item => ({ country: item.country, totalCities: item.cities.length }))
      .sort((a, b) => a.country.localeCompare(b.country))
    countries.forEach(({ country }, i) => {
      if (i > 0 && country.charAt(0) !== countries[i - 1].country.charAt(0)) {
        result.push(countries.slice(position, i))
        position = i
      }
      if (i === countries.length - 1) {
        result.push(countries.slice(position, countries.length))
      }
    })
    commit('updateOrderedCountries', result)
  },
  updateFiltersCleared({ commit }, value) {
    commit('updateFiltersCleared', value)
  },
  buildCountryFilterData({ commit }, hotels) {
    commit('updateFilterCountriesList', [...new Map(hotels.map(item => [item.country, { name: item.country, code: item.code, type: 'country', country: item.countryCode, city: item.cityCode }])).values()])
  },
  buildCityFilterData({ commit }, hotels) {
    commit('updateFilterCitiesList', [...new Map(hotels.map(item => [item.city, { name: item.city + ', ' + item.country, code: item.code, type: 'city', country: item.countryCode, city: item.cityCode }])).values()])
  },
  buildHotelFilterData({ commit }, hotels) {
    commit('updateFilterHotelsList', [...new Map(hotels.map(item => [item.name, { name: item.name + ', ' + item.city, code: item.code, type: 'hotel', country: item.countryCode, city: item.cityCode }])).values()])
  },
  getFilterParams({ commit, getters, dispatch }, promotion) {
    const { country, city, hotel, checkInDate, checkOutDate, adults, children } = getQueryParams(window.location.search)
    let filterDestination = {}
    let filterDates = {}
    let queryParamsError = false

    if (country) {
      filterDestination = discoveryService.buildDestinationReturningFilter(
        getters.filterCountriesList,
        country,
        'country')
      queryParamsError = !discoveryService.isDestinationParamOk(filterDestination)
    } else if (city) {
      filterDestination = discoveryService.buildDestinationReturningFilter(
        getters.filterCitiesList,
        city,
        'city'
      )
      queryParamsError = !discoveryService.isDestinationParamOk(filterDestination)
    } else if (hotel) {
      filterDestination = discoveryService.buildDestinationReturningFilter(
        getters.filterHotelsList,
        hotel,
        'hotel'
      )
      queryParamsError = !discoveryService.isDestinationParamOk(filterDestination)
    }
    commit('updateFilterDestination', filterDestination)

    if (checkInDate && checkOutDate) {
      const isDateFormatOk = discoveryService.areCheckinAndCheckoutDatesOk(checkInDate, checkOutDate)
      const isCheckOutPreviousThanCheckIn = promotion.stayStartDate && promotion.stayEndDate ? DateFactory.formatDate(checkInDate) > DateFactory.formatDate(checkOutDate) : false
      const isCheckInBetweenStayDates = promotion.stayStartDate && promotion.stayEndDate ? discoveryService.isDateBetweenDates(checkInDate, promotion.stayStartDate, promotion.stayEndDate) : true
      const isCheckOutBetweenStayDates = promotion.stayStartDate && promotion.stayEndDate ? discoveryService.isDateBetweenDates(checkOutDate, promotion.stayStartDate, promotion.stayEndDate) : true
      if (isDateFormatOk) {
        if (!isCheckInBetweenStayDates || !isCheckOutBetweenStayDates || isCheckOutPreviousThanCheckIn) {
          filterDates = {
            start: DateFactory.formatDate(checkInDate),
            end: DateFactory.formatDate(checkOutDate)
          }
          queryParamsError = true
        } else {
          filterDates = {
            start: DateFactory.formatDate(checkInDate),
            end: DateFactory.formatDate(checkOutDate)
          }
        }
      } else {
        filterDates = {
          start: checkInDate,
          end: checkOutDate
        }
        queryParamsError = true
      }
    } else {
      filterDates = discoveryService.getDefaultFilterDates(promotion)
    }
    commit('updateFilterDates', filterDates)

    var occupancyFromAdultsAndChildren = null
    try {
      occupancyFromAdultsAndChildren = getOccupancyFromAdultsAndChild(adults, children)
      if (!discoveryService.isOccupancyParamOk(occupancyFromAdultsAndChildren)) queryParamsError = true
      commit('updateFilterOccupancy', occupancyFromAdultsAndChildren)
    } catch {
      queryParamsError = true
    }
    dispatch('handleQueryParamsError', queryParamsError)
  },
  handleQueryParamsError({ getters }, queryParamsError) {
    if (queryParamsError) {
      global.ModalMsg.show(
        global.$('#modal-error'),
        { title: translate('promoFilterErrorTitle'), subtitle: translate('promoFilterErrorSubtitle') },
        null,
        { backdrop: 'static', keyboard: false },
        { show: true, closeModalOnly: false, label: translate('errBtnClose'), url: `/${getPageLanguage().toLowerCase()}/promotions` }
      )
    }
  },
  updateOccupancyFilter({ commit, dispatch }, occupancy) {
    commit('updateFilterOccupancy', Occupancy.fromJSON(occupancy.rooms))
    dispatch('updateDiscoveryFilters', {
      occupancy: serializeOccupancy(occupancy),
      dates: null,
      destination: null
    })
  },
  updateDatesFilter({ commit, dispatch }, dates) {
    commit('updateFilterDates', { start: DateFactory.formatDate(dates.start), end: DateFactory.formatDate(dates.end) })
    const datesObject = { checkInDate: DateFactory.formatDate(dates.start), checkOutDate: DateFactory.formatDate(dates.end) }
    dispatch('updateDiscoveryFilters', {
      occupancy: null,
      dates: datesObject,
      destination: null
    })
  },
  updateDestinationFilter({ commit, dispatch }, destination) {
    let destinationObject = {}
    if (Object.keys(destination).length > 0) {
      switch (destination.type) {
        case 'country':
          commit('updateFilterDestination', { name: destination.name, type: 'country', country: destination.country, city: destination.city, code: destination.code })
          destinationObject = { country: destination.country }
          break
        case 'city':
          commit('updateFilterDestination', { name: destination.name, type: 'city', country: destination.country, city: destination.city, code: destination.code })
          destinationObject = { city: destination.city }
          break
        case 'hotel':
          commit('updateFilterDestination', { name: destination.name, type: 'hotel', country: destination.country, city: destination.city, code: destination.code })
          destinationObject = { hotel: destination.code }
          break
        default:
          commit('updateFilterDestination', {})
          break
      }
    }
    dispatch('updateDiscoveryFilters', {
      occupancy: null,
      dates: null,
      destination: destinationObject
    })
  },
  updateDiscoveryFilters({ getters }, filters) {
    const { country, city, hotel, checkInDate, checkOutDate, adults, children, landingType, voucher } = getQueryParams(window.location.search)
    const datesObject = checkInDate && checkOutDate ? { checkInDate: DateFactory.formatDate(checkInDate), checkOutDate: DateFactory.formatDate(checkOutDate) } : null
    const occupancyObject = adults ? serializeOccupancy(getOccupancyFromAdultsAndChild(adults, children)) : null
    const filterCountry = country ? { country: country } : null
    const filterCity = city ? { city: city } : null
    const filterHotel = hotel ? { hotel: hotel } : null
    const promotion = getters.promotion

    let dateObject = {}
    if (filters.dates && discoveryService.isTodayBetweenStayDates(promotion)) {
      if (filters.dates?.checkInDate === DateFactory.formatDate(DateFactory.today()) && filters.dates?.checkOutDate === DateFactory.formatDate(DateFactory.addDays(DateFactory.today(), discoveryService.getMinLenghtOfStay(promotion)))) {
        dateObject = null
      } else {
        dateObject = filters.dates
      }
    } else if (filters.dates && !discoveryService.isTodayBetweenStayDates(promotion)) {
      if (filters.dates?.checkInDate === DateFactory.formatDate(promotion.stayStartDate) && filters.dates?.checkOutDate === DateFactory.formatDate(DateFactory.addDays(DateFactory.formatDate(promotion.stayStartDate), discoveryService.getMinLenghtOfStay(promotion)))) {
        dateObject = null
      } else {
        dateObject = filters.dates
      }
    } else {
      dateObject = datesObject
    }

    const destinationFilterObtained = filterCity || filterCountry || filterHotel
    const urlParamsObj = {
      ...(landingType ? { landingType: landingType } : null),
      ...(voucher ? { voucher: voucher } : null),
      ...filters.destination ? filters.destination : destinationFilterObtained,
      ...dateObject,
      ...filters.occupancy ? ((JSON.stringify(getOccupancyFromAdultsAndChild(filters.occupancy.adults, filters.occupancy.children)) === JSON.stringify(Occupancy.default())) ? null : filters.occupancy) : occupancyObject
    }
    const url = window.location.origin + window.location.pathname + stringify(urlParamsObj, { addQueryPrefix: true, arrayFormat: 'brackets', format: 'RFC1738' })
    window.location._search = url.includes('?') ? '?' + url.split('?')[1] : ''
    window.history.pushState('', '', url)
  },

  async getPromotionInfo({ dispatch }) {
    const { voucher } = getQueryParams(window.location.search)
    const modalAddPromocodeInput = document.querySelector('input#modal-promocode-input')
    if (modalAddPromocodeInput) {
      modalAddPromocodeInput.value = voucher
    }
    await dispatch('validatePromocode', voucher)
  },
  async validatePromocode({ dispatch, commit }, voucher) {
    try {
      const { promotionId, validateIdentity, bookingStartDate, bookingEndDate, reservationEndDate, reservationStartDate } = await discoveryService.validatePromocode(voucher)
      commit('setTmsDates', { bookingStartDate, bookingEndDate, reservationEndDate, reservationStartDate })
      commit('setValidateIdentity', validateIdentity)
      await dispatch('checkNominalPromocode', { validateIdentity, promotionId, voucher })
    } catch {
      dispatch('showModalExpiredPromocode')
    }
  },
  async checkNominalPromocode({ dispatch }, { validateIdentity, promotionId, voucher }) {
    if (validateIdentity) {
      await dispatch('getUserPromocodes', voucher)
    } else {
      await dispatch('getPromotion', { promotionId, voucher })
    }
  },
  async getUserPromocodes({ dispatch }, voucher) {
    try {
      const promocodeInfoFromTms = await loyaltyService.getPromocodes(voucher, null)
      const { status, promotionId } = promocodeInfoFromTms.vouchers[0]
      await dispatch('validateNominalPromocode', { promotionId, voucher, status })
    } catch {
      // eslint-disable-next-line
      if (AuthDispatcher.isLogged()) {
        discoveryService.handlePreventCloseModals('modal-owner-not-correct')
      } else {
        discoveryService.handlePreventCloseModals('modal-rewards-login-discovery')
      }
    }
  },

  async validateNominalPromocode({ dispatch }, { promotionId, voucher, status }) {
    const validationError = global.ModalAddPromocode.validateNominalPromocode(status)
    if (!validationError) {
      await dispatch('getPromotion', { promotionId, voucher })
    } else {
      dispatch('showModalExpiredPromocode')
    }
  },

  async getPromotion({ commit, dispatch, getters }, { promotionId, voucher }) {
    try {
      const promotion = await discoveryService.getPromotion(promotionId)

      const checkTmsDates = getters.tmsDates

      promotion.bookingStartDate = checkTmsDates.bookingStartDate || promotion?.bookingStartDate
      promotion.bookingEndDate = checkTmsDates.bookingEndDate || promotion?.bookingEndDate
      promotion.stayStartDate = checkTmsDates.reservationStartDate || promotion?.stayStartDate
      promotion.stayEndDate = checkTmsDates.reservationEndDate || promotion?.stayEndDate

      const path = promotion?.pageUrl?.split('promotions')[1]
      const checkLandingUrl = path ? window.location.pathname.includes(path) : false
      if (!checkLandingUrl && !isLocalEnviroment) {
        dispatch('showModalExpiredPromocode')
        // eslint-disable-next-line
        return
      }
      commit('setPromotion', { ...promotion, code: voucher })
      await dispatch('getOrderedCountries')
    } catch {
      localStorage.setItem('voucherBook', voucher)
      window.searchBarVue.$emit('show-modal-modify-dates', { checkInDate: getters.filterDates?.start, checkOutDate: getters.filterDates?.end },
        'discovery')
    }
  },
  mapFieldsToHotels({ commit, getters }, { hotelsWithFields, fieldsToMap }) {
    if (hotelsWithFields.length === 0) return
    const result = cloneDeep(getters.hotels)
    hotelsWithFields.forEach(hotelWithField => {
      const indexHotel = result.findIndex(hotel => hotel.code === hotelWithField.code)
      if (result[indexHotel]) {
        fieldsToMap.forEach(field => { result[indexHotel][field.key] = hotelWithField[field.key] || field.default })
      }
    })
    commit('updateHotels', result)
  },
  async getHotelsAvailability({ dispatch, getters }, { hotelCodes, onFilters, isDiscovery }) {
    const requestHotelCodes = discoveryService.filterRequestedHotels(getters.hotels, hotelCodes, (onFilters) ? null : 'price')
    if (requestHotelCodes.length === 0 && !onFilters) return
    const taxIncludedRegion = (taxRegion('DEFAULT_TAXES_INCLUDED_COUNTRY_CODES') ? true : undefined) || (taxRegion('DEFAULT_TAXES_EXCLUDED_COUNTRY_CODES') ? false : undefined)
    const params = {
      searchType: 'lowest',
      voucherCode: isDiscovery ? getters.promotion?.code : '',
      sourceOfBusiness: global.device.desktop() ? 'desktop' : 'mobile',
      hotelCodes: hotelCodes.join(','),
      memberOnlyRatesHotelCodes: hotelCodes.join(','),
      adults: isDiscovery ? getters.totalAdults : 2,
      children: isDiscovery ? getters.totalChildren : 1,
      rooms: isDiscovery ? getters.filterOccupancy.numberOfRooms : 1,
      startCheckDate: getters.filterDates.start,
      nights: DateFactory.daysBetween(getters.filterDates.start, getters.filterDates.end),
      futureDays: isDiscovery ? 1 : 62,
      taxIncludedRegion: taxIncludedRegion
    }
    const queryParams = global.Utils.stringifyQueryParams(params)
    const avail = await discoveryService.getHotelsAvailability(queryParams)
    const availabilityHotels = avail.hotels.map(hotel => ({
      code: hotel.code,
      price: hotel.priceFrom?.amount || -1,
      formattedAmount: hotel.priceFrom?.formattedAmount
    }))
    // Refactor discovery page
    if (!isDiscovery) {
      try {
        const hotelsInfoBasic = await hotelService.getHotels(hotelCodes)
        dispatch('mapFieldsToHotels', { hotelsWithFields: hotelsInfoBasic, fieldsToMap: [{ key: 'brand' }, { key: 'name' }, { key: 'city' }, { key: 'cityCode' }, { key: 'countryCode' }] })
      } catch (e) {
        // eslint-disable-next-line
        console.error('Unable to retrieve hotel info', e)
      }
    }
    dispatch('mapFieldsToHotels', { hotelsWithFields: availabilityHotels, fieldsToMap: [{ key: 'price', default: -1 }, { key: 'formattedAmount' }] })
  },
  async getHotelGalleries({ dispatch, getters }, hotelCodes) {
    const galleriestHotelCodes = discoveryService.filterRequestedHotels(getters.hotels, hotelCodes, 'galleries')
    if (galleriestHotelCodes.length === 0) {
      return
    }
    try {
      const galleries = await discoveryService.getHotelGalleries(galleriestHotelCodes)
      dispatch('mapFieldsToHotels', { hotelsWithFields: galleries.hotels, fieldsToMap: [{ key: 'galleries', default: [] }, { key: 'overviewPath' }] })
    } catch {
      // eslint-disable-next-line
      return
    }
  },
  async getTripadvisorRatings({ dispatch, getters }, hotels) {
    const hotelCodes = discoveryService.getHotelsCode(hotels)
    const tripAdvisorRatingHotelCodes = discoveryService.filterRequestedHotels(getters.hotels, hotelCodes, 'rating')
    if (tripAdvisorRatingHotelCodes.length === 0) return

    try {
      let tripAdvisorRating = []
      tripAdvisorRating = await tripAdvisorService.getTripAdvisorRating(hotelCodes)
      dispatch('mapFieldsToHotels', { hotelsWithFields: tripAdvisorRating.length !== 0 ? tripAdvisorRating : hotels, fieldsToMap: [{ key: 'rating' }] })
    } catch {
      // eslint-disable-next-line
      return
    }
  },

  async navigateToHotels({ dispatch, commit, getters }, { hotels, requestGalleries = true, onFilters = false, isDiscovery = false }) {
    if (getters.loadingHotels) return
    commit('setLoadingHotels', true)
    const hotelCodes = discoveryService.getHotelsCode(hotels)
    dispatch('getTripadvisorRatings', hotels)
    if (requestGalleries) {
      dispatch('getHotelGalleries', hotelCodes)
    }
    await Promise.resolve(dispatch('getHotelsAvailability', { hotelCodes, onFilters, isDiscovery })).finally(() => commit('setLoadingHotels', false))
  },
  showModalExpiredPromocode() {
    discoveryService.handlePreventCloseModals('modal-expired-promocode')
  }
}
